import { render, staticRenderFns } from "./ClientsShow.vue?vue&type=template&id=b53b9274&"
import script from "./ClientsShow.vue?vue&type=script&lang=js&"
export * from "./ClientsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports